<div class="search-page" [class.embed]="embedded()">

  <!-- ============ PAGE HEADER ============ -->
  <!-- Masqué en mode embarqué (§8) : le tiroir a son propre en-tête. -->
  @if (!embedded()) {
    <header class="page-h">
      <div class="titles">
        <h1>{{ 'SEARCH_PAGE.TITLE_A' | translate }} <span class="accent">{{ 'SEARCH_PAGE.TITLE_B' | translate }}</span></h1>
        <span class="sub">{{ 'SEARCH_PAGE.SUB' | translate }}</span>
      </div>
      <div class="stats">
        <div class="it"><span class="n">{{ totalHits() | number }}</span><span class="l">{{ 'SEARCH_PAGE.STAT_LYRICS' | translate }}</span></div>
        <div class="it"><span class="n">{{ recueils().length }}</span><span class="l">{{ 'SEARCH_PAGE.STAT_RECUEILS' | translate }}</span></div>
        <div class="it"><span class="n">{{ LANGUAGES.length }}</span><span class="l">{{ 'SEARCH_PAGE.STAT_LANGS' | translate }}</span></div>
      </div>
    </header>
  }

  <!-- ============ SEARCH BAR + AUTOCOMPLETE ============ -->
  <div class="search-shell">
    <div class="search-bar" [class.has-text]="query()">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
      </svg>
      <input
        #queryInput
        type="search"
        [value]="query()"
        (input)="onQueryInput($any($event.target).value)"
        (focus)="onSearchInputFocus()"
        (keydown)="onQueryKeydown($event)"
        [placeholder]="'SEARCH_PAGE.PLACEHOLDER' | translate"
        autocomplete="off"
        data-testid="search-query-input"
      />
      <button class="clear" (click)="clearQuery()" type="button" [title]="'SEARCH_PAGE.CLEAR' | translate" data-testid="btn-clear-query">
        <svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor" stroke-width="2.5">
          <line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/>
        </svg>
      </button>
      <button
        #filtersBtn
        class="filters-fab"
        [class.on]="filtersPanelOpen()"
        type="button"
        (click)="toggleFiltersPanel($event)"
        aria-haspopup="true"
        [attr.aria-expanded]="filtersPanelOpen()"
        data-testid="btn-filters">
        <i class="ls-filter"></i>
        {{ 'SEARCH_PAGE.FILTERS' | translate }}
        @if (activeFilterCount() > 0) {
          <span class="badge">{{ activeFilterCount() }}</span>
        }
      </button>
      <button class="go" type="button" (click)="onSearchSubmit()" data-testid="btn-search-submit">
        {{ 'SEARCH_PAGE.SUBMIT' | translate }}
        <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.4">
          <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
        </svg>
      </button>
    </div>

    <!-- ====== Filtre rapide média — checkboxes indépendantes, sur la page (PAS dans le
         panneau Filtres) : cf. décision utilisateur "ajouter un filtre supplémentaire pour
         tier les lyrics qui on des medias audio et partition. accessible depuis la page, pas
         dans le menu filtre afin d'eviter l'exemple image 1". ====== -->
    <div class="quick-media-filters">
      <label class="quick-chk">
        <input
          type="checkbox"
          [checked]="hasAudioFilter()"
          (change)="toggleHasAudioFilter()"
          data-testid="chk-has-audio"
        />
        {{ 'SEARCH_PAGE.WITH_AUDIO' | translate }}
      </label>
      <label class="quick-chk">
        <input
          type="checkbox"
          [checked]="hasPartitionFilter()"
          (change)="toggleHasPartitionFilter()"
          data-testid="chk-has-partition"
        />
        {{ 'SEARCH_PAGE.WITH_SCORE' | translate }}
      </label>
    </div>

    <!-- ====== FILTRES — panneau flottant (§10.1) ======
         Ancré via CDK Overlay (cf. commentaire sur filtersBtnRef dans search.ts) — remplace
         l'ancien panneau positionné en position: absolute, fragile hors du bouton "Filtres". -->
    @if (filtersBtnEl(); as originEl) {
      <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="originEl"
        [cdkConnectedOverlayOpen]="filtersPanelOpen()"
        [cdkConnectedOverlayPositions]="popoverPositions"
        [cdkConnectedOverlayHasBackdrop]="true"
        [cdkConnectedOverlayPush]="true"
        cdkConnectedOverlayBackdropClass="ls-popover-backdrop"
        (backdropClick)="closeFiltersPanel()"
        (detach)="closeFiltersPanel()">
      <div
        class="filters-panel"
        role="dialog"
        [attr.aria-label]="'SEARCH_PAGE.FILTERS' | translate"
        tabindex="-1"
        data-testid="filters-panel"
        (keydown.escape)="onFiltersEscape($event)">
        <div class="filters-panel-h">
          <h3>{{ 'SEARCH_PAGE.FILTERS' | translate }}</h3>
          <div class="filters-panel-actions">
            <button
              class="reset"
              [class.dim]="activeFilterCount() === 0"
              (click)="clearFilters()"
              type="button"
              data-testid="btn-clear-all-filters"
            >{{ 'SEARCH_PAGE.CLEAR_ALL' | translate }}</button>
            <button class="close" type="button" (click)="closeFiltersPanel()" [attr.aria-label]="'SEARCH_PAGE.CLOSE_FILTERS' | translate" data-testid="btn-close-filters">
              <i class="ls-x"></i>
            </button>
          </div>
        </div>

        <div class="filters-grid">
          <!-- Recueil -->
          <div class="filter-block">
            <h4>{{ 'SEARCH_PAGE.BLOCK_RECUEIL' | translate }} @if (selectedRecueils().length > 0) { <span class="count">{{ selectedRecueils().length }}</span> }</h4>
            <div class="ms" [class.ms-open]="msOpen() === 'recueil'">
              <button class="ms-trigger" type="button" (click)="toggleMs('recueil', $event)" data-testid="ms-trigger-recueil">
                <span class="chips-row">
                  @if (selectedRecueils().length === 0) {
                    <span class="placeholder">{{ 'SEARCH_PAGE.ALL_RECUEILS' | translate }}</span>
                  } @else {
                    <span class="chip">{{ recueilTriggerLabel() }}</span>
                    @if (selectedRecueils().length > 1) {
                      <span class="chip more">+{{ selectedRecueils().length - 1 }}</span>
                    }
                  }
                </span>
                <svg class="chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4">
                  <polyline points="6 9 12 15 18 9"/>
                </svg>
              </button>
              <div class="ms-pop" [class.open]="msOpen() === 'recueil'">
                <div class="ms-pop-search">
                  <i class="ls-search"></i>
                  <input
                    type="text"
                    [placeholder]="'SEARCH_PAGE.FILTER_PLACEHOLDER' | translate"
                    [value]="msFilterQuery('recueil')"
                    (input)="setMsFilterQuery('recueil', $any($event.target).value)"
                    (click)="$event.stopPropagation()"
                    data-testid="ms-search-recueil" />
                </div>
                <div class="ms-pop-list">
                  @for (r of filteredRecueils(); track r.code) {
                    <label class="ms-opt">
                      <input type="checkbox" [checked]="isRecueilSelected(r.code)" (change)="toggleRecueil(r.code)" [attr.data-testid]="'ms-opt-recueil-' + r.code" />
                      <span class="lbl">{{ r.name }}</span>
                      <span class="num">{{ recueilLyricCount(r.code) }}</span>
                    </label>
                  }
                </div>
                <div class="ms-pop-foot">
                  <span>{{ (filteredRecueils().length > 1 ? 'SEARCH_PAGE.OPTIONS_MANY' : 'SEARCH_PAGE.OPTIONS_ONE') | translate: { count: filteredRecueils().length } }}</span>
                  @if (selectedRecueils().length > 0) {
                    <button type="button" (click)="clearRecueilFilter()" data-testid="btn-clear-filter-recueil">{{ 'SEARCH_PAGE.CLEAR' | translate }}</button>
                  }
                </div>
              </div>
            </div>
          </div>

          <!-- Langue -->
          <div class="filter-block">
            <h4>{{ 'SEARCH_PAGE.BLOCK_LANGUAGE' | translate }} @if (selectedLanguages().length > 0) { <span class="count">{{ selectedLanguages().length }}</span> }</h4>
            <div class="ms" [class.ms-open]="msOpen() === 'lang'">
              <button class="ms-trigger" type="button" (click)="toggleMs('lang', $event)" data-testid="ms-trigger-lang">
                <span class="chips-row">
                  @if (selectedLanguages().length === 0) {
                    <span class="placeholder">{{ 'SEARCH_PAGE.ALL_LANGUAGES' | translate }}</span>
                  } @else {
                    <span class="chip">{{ langTriggerLabel() }}</span>
                    @if (selectedLanguages().length > 1) {
                      <span class="chip more">+{{ selectedLanguages().length - 1 }}</span>
                    }
                  }
                </span>
                <svg class="chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4">
                  <polyline points="6 9 12 15 18 9"/>
                </svg>
              </button>
              <div class="ms-pop" [class.open]="msOpen() === 'lang'">
                <div class="ms-pop-search">
                  <i class="ls-search"></i>
                  <input
                    type="text"
                    [placeholder]="'SEARCH_PAGE.FILTER_PLACEHOLDER' | translate"
                    [value]="msFilterQuery('lang')"
                    (input)="setMsFilterQuery('lang', $any($event.target).value)"
                    (click)="$event.stopPropagation()"
                    data-testid="ms-search-lang" />
                </div>
                <div class="ms-pop-list">
                  @for (l of filteredLanguages(); track l.code) {
                    <label class="ms-opt">
                      <input type="checkbox" [checked]="isLanguageSelected(l.code)" (change)="toggleLanguage(l.code)" [attr.data-testid]="'ms-opt-lang-' + l.code" />
                      <span class="lbl">{{ l.label }}</span>
                    </label>
                  }
                </div>
                <div class="ms-pop-foot">
                  <span>{{ (filteredLanguages().length > 1 ? 'SEARCH_PAGE.OPTIONS_MANY' : 'SEARCH_PAGE.OPTIONS_ONE') | translate: { count: filteredLanguages().length } }}</span>
                  @if (selectedLanguages().length > 0) {
                    <button type="button" (click)="clearLanguageFilter()" data-testid="btn-clear-filter-lang">{{ 'SEARCH_PAGE.CLEAR' | translate }}</button>
                  }
                </div>
              </div>
            </div>
          </div>

          <!-- Genre -->
          <div class="filter-block">
            <h4>{{ 'SEARCH_PAGE.BLOCK_GENRE' | translate }} @if (selectedGenres().length > 0) { <span class="count">{{ selectedGenres().length }}</span> }</h4>
            <div class="ms" [class.ms-open]="msOpen() === 'genre'">
              <button class="ms-trigger" type="button" (click)="toggleMs('genre', $event)" data-testid="ms-trigger-genre">
                <span class="chips-row">
                  @if (selectedGenres().length === 0) {
                    <span class="placeholder">{{ 'SEARCH_PAGE.ALL_GENRES' | translate }}</span>
                  } @else {
                    <span class="chip">{{ allGenres().find(g => g.id === selectedGenres()[0])?.name ?? selectedGenres()[0] }}</span>
                    @if (selectedGenres().length > 1) {
                      <span class="chip more">+{{ selectedGenres().length - 1 }}</span>
                    }
                  }
                </span>
                <svg class="chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4">
                  <polyline points="6 9 12 15 18 9"/>
                </svg>
              </button>
              <div class="ms-pop" [class.open]="msOpen() === 'genre'">
                <div class="ms-pop-search">
                  <i class="ls-search"></i>
                  <input
                    type="text"
                    [placeholder]="'SEARCH_PAGE.FILTER_PLACEHOLDER' | translate"
                    [value]="msFilterQuery('genre')"
                    (input)="setMsFilterQuery('genre', $any($event.target).value)"
                    (click)="$event.stopPropagation()"
                    data-testid="ms-search-genre" />
                </div>
                <div class="ms-pop-list">
                  @for (g of filteredGenres(); track g.id) {
                    <label class="ms-opt">
                      <input type="checkbox" [checked]="isGenreSelected(g.id)" (change)="toggleGenre(g.id)" [attr.data-testid]="'ms-opt-genre-' + g.id" />
                      <span class="lbl">{{ g.name }}</span>
                    </label>
                  }
                </div>
                <div class="ms-pop-foot">
                  <span>{{ (filteredGenres().length > 1 ? 'SEARCH_PAGE.OPTIONS_MANY' : 'SEARCH_PAGE.OPTIONS_ONE') | translate: { count: filteredGenres().length } }}</span>
                  @if (selectedGenres().length > 0) {
                    <button type="button" (click)="clearGenreFilter()" data-testid="btn-clear-filter-genre">{{ 'SEARCH_PAGE.CLEAR' | translate }}</button>
                  }
                </div>
              </div>
            </div>
          </div>

          <!-- Style -->
          <div class="filter-block">
            <h4>{{ 'SEARCH_PAGE.BLOCK_STYLE' | translate }} @if (selectedStyles().length > 0) { <span class="count">{{ selectedStyles().length }}</span> }</h4>
            <div class="ms" [class.ms-open]="msOpen() === 'style'">
              <button class="ms-trigger" type="button" (click)="toggleMs('style', $event)" data-testid="ms-trigger-style">
                <span class="chips-row">
                  @if (selectedStyles().length === 0) {
                    <span class="placeholder">{{ 'SEARCH_PAGE.ALL_STYLES' | translate }}</span>
                  } @else {
                    <span class="chip">{{ allStyles().find(s => s.id === selectedStyles()[0])?.name ?? selectedStyles()[0] }}</span>
                    @if (selectedStyles().length > 1) {
                      <span class="chip more">+{{ selectedStyles().length - 1 }}</span>
                    }
                  }
                </span>
                <svg class="chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4">
                  <polyline points="6 9 12 15 18 9"/>
                </svg>
              </button>
              <div class="ms-pop" [class.open]="msOpen() === 'style'">
                <div class="ms-pop-search">
                  <i class="ls-search"></i>
                  <input
                    type="text"
                    [placeholder]="'SEARCH_PAGE.FILTER_PLACEHOLDER' | translate"
                    [value]="msFilterQuery('style')"
                    (input)="setMsFilterQuery('style', $any($event.target).value)"
                    (click)="$event.stopPropagation()"
                    data-testid="ms-search-style" />
                </div>
                <div class="ms-pop-list">
                  @for (s of filteredStyles(); track s.id) {
                    <label class="ms-opt">
                      <input type="checkbox" [checked]="isStyleSelected(s.id)" (change)="toggleStyle(s.id)" [attr.data-testid]="'ms-opt-style-' + s.id" />
                      <span class="lbl">{{ s.name }}</span>
                    </label>
                  }
                </div>
                <div class="ms-pop-foot">
                  <span>{{ (filteredStyles().length > 1 ? 'SEARCH_PAGE.OPTIONS_MANY' : 'SEARCH_PAGE.OPTIONS_ONE') | translate: { count: filteredStyles().length } }}</span>
                  @if (selectedStyles().length > 0) {
                    <button type="button" (click)="clearStyleFilter()" data-testid="btn-clear-filter-style">{{ 'SEARCH_PAGE.CLEAR' | translate }}</button>
                  }
                </div>
              </div>
            </div>
          </div>

          <!-- Catégorie -->
          <div class="filter-block">
            <h4>{{ 'SEARCH_PAGE.BLOCK_CATEGORY' | translate }} @if (selectedCats().length > 0) { <span class="count">{{ selectedCats().length }}</span> }</h4>
            <div class="ms" [class.ms-open]="msOpen() === 'cat'">
              <button class="ms-trigger" type="button" (click)="toggleMs('cat', $event)" data-testid="ms-trigger-cat">
                <span class="chips-row">
                  @if (selectedCats().length === 0) {
                    <span class="placeholder">{{ 'SEARCH_PAGE.ALL_CATEGORIES' | translate }}</span>
                  } @else {
                    <span class="chip">{{ allCategories().find(c => c.id === selectedCats()[0])?.name ?? selectedCats()[0] }}</span>
                    @if (selectedCats().length > 1) {
                      <span class="chip more">+{{ selectedCats().length - 1 }}</span>
                    }
                  }
                </span>
                <svg class="chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4">
                  <polyline points="6 9 12 15 18 9"/>
                </svg>
              </button>
              <div class="ms-pop" [class.open]="msOpen() === 'cat'">
                <div class="ms-pop-search">
                  <i class="ls-search"></i>
                  <input
                    type="text"
                    [placeholder]="'SEARCH_PAGE.FILTER_PLACEHOLDER' | translate"
                    [value]="msFilterQuery('cat')"
                    (input)="setMsFilterQuery('cat', $any($event.target).value)"
                    (click)="$event.stopPropagation()"
                    data-testid="ms-search-cat" />
                </div>
                <div class="ms-pop-list">
                  @for (c of filteredCategories(); track c.id) {
                    <label class="ms-opt">
                      <input type="checkbox" [checked]="isCatSelected(c.id)" (change)="toggleCat(c.id)" [attr.data-testid]="'ms-opt-cat-' + c.id" />
                      <span class="lbl">{{ c.name }}</span>
                    </label>
                  }
                </div>
                <div class="ms-pop-foot">
                  <span>{{ (filteredCategories().length > 1 ? 'SEARCH_PAGE.OPTIONS_MANY' : 'SEARCH_PAGE.OPTIONS_ONE') | translate: { count: filteredCategories().length } }}</span>
                  @if (selectedCats().length > 0) {
                    <button type="button" (click)="clearCatFilter()" data-testid="btn-clear-filter-cat">{{ 'SEARCH_PAGE.CLEAR' | translate }}</button>
                  }
                </div>
              </div>
            </div>
          </div>

          <!-- Tonalité et Tempo côte à côte sur la dernière rangée (§10.1) -->
          <div class="filter-block">
            <h4>{{ 'SEARCH_PAGE.BLOCK_KEY' | translate }} @if (selectedKeys().length > 0) { <span class="count">{{ selectedKeys().length }}</span> }</h4>
            <div class="key-pad">
              @for (k of KEYS; track k.value) {
                <button
                  class="key-btn"
                  [class.on]="isKeySelected(k.value)"
                  (click)="toggleKey(k.value)"
                  type="button"
                  [attr.data-testid]="'key-btn-' + k.value"
                >{{ k.label }}</button>
              }
            </div>
            <div class="key-toggle">
              <button [class.on]="keyMode() === 'any'"   (click)="onKeyModeChange('any')"   type="button" data-testid="key-mode-any">{{ 'SEARCH_PAGE.KEY_ANY' | translate }}</button>
              <button [class.on]="keyMode() === 'major'" (click)="onKeyModeChange('major')" type="button" data-testid="key-mode-major">{{ 'SEARCH_PAGE.KEY_MAJOR' | translate }}</button>
              <button [class.on]="keyMode() === 'minor'" (click)="onKeyModeChange('minor')" type="button" data-testid="key-mode-minor">{{ 'SEARCH_PAGE.KEY_MINOR' | translate }}</button>
            </div>
          </div>

          <div class="filter-block">
            <h4>{{ 'SEARCH_PAGE.BLOCK_TEMPO' | translate }} @if (bpmMin() !== 60 || bpmMax() !== 180) { <span class="count">{{ bpmMin() }}–{{ bpmMax() }}</span> }</h4>
            <div class="bpm-wrap">
              <div class="bpm-vals">
                <span class="v">{{ bpmMin() }}</span>
                <span class="v">{{ bpmMax() }}</span>
              </div>
              <div class="bpm-track">
                <div class="range" [style]="bpmRangeStyle()"></div>
                <input type="range" min="40" max="200" step="2"
                  [value]="bpmMin()"
                  (input)="onBpmMinChange(+$any($event.target).value)"
                  data-testid="bpm-range-min" />
                <input type="range" min="40" max="200" step="2"
                  [value]="bpmMax()"
                  (input)="onBpmMaxChange(+$any($event.target).value)"
                  data-testid="bpm-range-max" />
              </div>
              <div class="bpm-marks">
                <span>40</span><span>80</span><span>120</span><span>160</span><span>200</span>
              </div>
              <div class="bpm-presets">
                @for (preset of BPM_PRESETS; track preset.label) {
                  <button
                    class="bpm-preset"
                    [class.on]="isBpmPresetActive(preset)"
                    (click)="applyBpmPreset(preset)"
                    type="button"
                    [attr.data-testid]="'bpm-preset-' + preset.label"
                  >{{ 'SEARCH_PAGE.BPM.' + preset.key | translate }} <small>· {{ preset.sub }}</small></button>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      </ng-template>
    }

    <!-- Autocomplete (composant partagé) -->
    <ls-search-autocomplete-panel
      [open]="ac.open()"
      [query]="query()"
      [sections]="ac.sections()"
      [activeItem]="ac.activeItem()"
      [recent]="ac.recent()"
      [popularTags]="popularTags"
      (picked)="onAutocompleteSelect($event)" />
  </div>

  <!-- ============ RESULTS ============ -->
  <div class="results-wrap">
    <!-- ====== RESULTS ====== -->
    <section>
      <!-- Results header -->
      <div class="results-h">
        <div>
          <div class="count">
            @if (isLoading()) {
              <span class="n loading">…</span>
            } @else {
              <span class="n">{{ totalHits() | number }}</span>
            }
            {{ (approximateFor() !== null ? 'SEARCH_PAGE.SUGGESTIONS_UNIT' : 'SEARCH_PAGE.RESULTS_UNIT') | translate }}
          </div>
          @if (!embedded()) {
            <div class="sub">{{ 'SEARCH_PAGE.SORTED_BY' | translate: { label: ('SEARCH_PAGE.SORTED.' + sortBy() | translate) } }}</div>
          }
        </div>
        <div class="right">
          <div class="sort-wrap">
            <span>{{ 'SEARCH_PAGE.SORT_LABEL' | translate }}</span>
            <select (change)="onSortChange($any($event.target).value)" data-testid="sort-select">
              <option value="relevance">{{ 'SEARCH_PAGE.SORT.relevance' | translate }}</option>
              <option value="popular">{{ 'SEARCH_PAGE.SORT.popular' | translate }}</option>
              <option value="recent">{{ 'SEARCH_PAGE.SORT.recent' | translate }}</option>
              <option value="az">{{ 'SEARCH_PAGE.SORT.az' | translate }}</option>
              <option value="za">{{ 'SEARCH_PAGE.SORT.za' | translate }}</option>
              <option value="num0-9">{{ 'SEARCH_PAGE.SORT.num0-9' | translate }}</option>
              <option value="num9-0">{{ 'SEARCH_PAGE.SORT.num9-0' | translate }}</option>
              <option value="bpm">{{ 'SEARCH_PAGE.SORT.bpm' | translate }}</option>
            </select>
          </div>
          @if (!embedded()) {
            <div class="view-toggle">
              <button [class.on]="view() === 'onecol'" (click)="onViewChange('onecol')" type="button" [title]="'SEARCH_PAGE.VIEW_ONE' | translate" [attr.aria-label]="'SEARCH_PAGE.VIEW_ONE' | translate" data-testid="btn-view-onecol">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
                  <line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/>
                  <line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/>
                </svg>
              </button>
              <button [class.on]="view() === 'grid'" (click)="onViewChange('grid')" type="button" [title]="'SEARCH_PAGE.VIEW_TWO' | translate" [attr.aria-label]="'SEARCH_PAGE.VIEW_TWO' | translate" data-testid="btn-view-grid">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
                  <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
                  <rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>
                </svg>
              </button>
            </div>
          }
        </div>
      </div>

      <!-- Suggestions : aucun chant ne contient tous les mots saisis, ce n'est pas le résultat de la recherche -->
      @if (approximateFor() !== null && !isLoading()) {
        <div class="approx-note" role="note" data-testid="approx-note">
          <strong>{{ 'SEARCH_PAGE.APPROX_TITLE' | translate: { query: approximateFor() } }}</strong>
          <span>{{ 'SEARCH_PAGE.APPROX_HINT' | translate }}</span>
        </div>
      }

      <!-- Active filter chips -->
      @if (activeChips().length > 0) {
        <div class="active-chips">
          @for (chip of activeChips(); track chip.category + chip.value) {
            <span class="ac-chip" [attr.data-testid]="'active-chip-' + chip.category + '-' + chip.value">
              <span class="lbl">{{ 'SEARCH_PAGE.CHIPS.' + chip.category | translate }}</span>
              {{ chip.label }}
              <button class="x" type="button" (click)="removeChip(chip)" [title]="'SEARCH_PAGE.REMOVE' | translate">
                <svg viewBox="0 0 24 24" width="9" height="9" fill="none" stroke="currentColor" stroke-width="3">
                  <line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/>
                </svg>
              </button>
            </span>
          }
          <button class="ac-clear" type="button" (click)="clearFilters()" data-testid="btn-clear-all-chips">{{ 'SEARCH_PAGE.CLEAR_ALL' | translate }}</button>
        </div>
      }

      <!-- État de chargement -->
      @if (isLoading()) {
        <div class="loading-state">
          <div class="spinner"></div>
          <span>{{ 'SEARCH_PAGE.LOADING' | translate }}</span>
        </div>
      }

      <!-- État d'erreur -->
      @if (error() && !isLoading()) {
        <div class="error-state">
          <p>{{ error() }}</p>
          <button type="button" (click)="clearFilters()">{{ 'SEARCH_PAGE.RETRY' | translate }}</button>
        </div>
      }

      @if (!isLoading() && !error()) {
        @if (results().length > 0) {

          <!-- Résultats — LyricCard/LyricCardGrid (§9/§10.2), une seule carte pour toute
               liste de chants du projet. 2 colonnes par défaut, 1 colonne via la bascule.
               En mode embarqué (§8/§9), trailingAction="add" remplace le menu ⋮. -->
          <div class="res-list" [class.onecol]="view() === 'onecol'">
            @for (lyric of results(); track lyric.id) {
              <div class="res-wrap">
                <ls-lyric-card
                  [lyric]="lyric"
                  [href]="'/' + lang() + '/lyric/' + lyric.slug"
                  [coverColors]="getArtColors(lyric.idLegacy)"
                  [titleHtml]="highlight(lyric.title)"
                  [showArtist]="true"
                  [showSigle]="true"
                  [showRecueilOrAlbumDisplay]="true"
                  [metric]="durationLabel(lyric.durationSeconds) ? { kind: 'duration', value: durationLabel(lyric.durationSeconds)! } : undefined"
                  [trailingAction]="embedded() ? ((hasAudio(lyric) || isLyricAdded(lyric.id)) ? 'add' : 'none') : 'menu'"
                  [added]="embedded() ? isLyricAdded(lyric.id) : false"
                  [playlistContext]="playlistContext()"
                  [showPlayOverlay]="embedded()"
                  [showOpenLyrics]="true"
                  [showListenNow]="true"
                  [showPlayNext]="true"
                  [showAddToPlaylist]="true"
                  [showFavorite]="true"
                  [showDownload]="true"
                  [showProject]="true"
                  [showTranspose]="true"
                  [showShare]="true"
                  [showViewRecueil]="true"
                  [showReport]="true"
                  [attr.data-testid]="'song-row-' + lyric.id"
                  (trackAddedToPlaylist)="onAddTrack(lyric)" />
              </div>
            }
          </div>

          <!-- Pagination — masquée en mode embarqué (§8) -->
          @if (!embedded() && totalPages() > 1) {
            <div class="pagination">
              <button [class.dim]="page() <= 1" (click)="goToPage(page() - 1)" type="button" [disabled]="page() <= 1" data-testid="pagination-prev">←</button>
              @if (pages()[0] > 1) {
                <button (click)="goToPage(1)" type="button" data-testid="pagination-page-1">1</button>
                @if (pages()[0] > 2) { <span class="ellipsis">…</span> }
              }
              @for (p of pages(); track p) {
                <button [class.on]="p === page()" (click)="goToPage(p)" type="button" [attr.data-testid]="'pagination-page-' + p">{{ p }}</button>
              }
              @if (pages()[pages().length - 1] < totalPages()) {
                @if (pages()[pages().length - 1] < totalPages() - 1) { <span class="ellipsis">…</span> }
                <button (click)="goToPage(totalPages())" type="button" [attr.data-testid]="'pagination-page-' + totalPages()">{{ totalPages() }}</button>
              }
              <button [class.dim]="page() >= totalPages()" (click)="goToPage(page() + 1)" type="button" [disabled]="page() >= totalPages()" data-testid="pagination-next">→</button>
            </div>
          }

        } @else {
          <div class="empty-state">
            <div class="big">{{ 'SEARCH_PAGE.EMPTY_TITLE' | translate }}</div>
            <p class="desc">{{ 'SEARCH_PAGE.EMPTY_DESC' | translate }}</p>
            <button class="reset-btn" (click)="clearFilters()" type="button" data-testid="btn-reset-filters-empty">{{ 'SEARCH_PAGE.EMPTY_RESET' | translate }}</button>
          </div>
        }
      }
    </section>

    <!-- Après les chants (10 par page) : playlists publiques, albums puis artistes qui correspondent à la saisie, en
         rangées de même apparence que la page Découvrir ; chaque rubrique se masque quand elle est vide.
         Hors mode embarqué (tiroir « Ajouter des chants »). -->
    @if (!embedded()) {
      <ls-search-extras [query]="query()" />
    }
  </div>

  <!-- Toast déplacé vers app.html (ToastService, monté une fois à la racine) — cf. décision
       utilisateur "pk le toast n'est pas réutilisable genre un composant" / "pk ce n'est pas un
       service". -->
</div>
